import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DownloadFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.86 8.94L18.08 10.18L12 16.26L5.92 10.18L7.14 8.94L11.06 12.9V3H12.94V12.9L16.86 8.94ZM18.56 19H5.44V17.16H18.56V19Z" />
    </SvgIcon>
  );
});
